import { httpRequest } from "@/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type Props = {
  page: string | null;
  proceduresId: string;
  date_start: string;
  date_end: string;
  status: string;
  patientsId: string;
  employeesId: string;
  payment_history: string;
  per_page?: string | null;
};

const requestReportSchedulingPDF = async ({ status, page, per_page, employeesId, patientsId, payment_history, date_start, date_end, proceduresId }: Props) => {
  const response = await httpRequest.get(`/schedulings-report-in-pdf?status=${status}&proceduresId=${proceduresId}&date_start=${date_start}&date_end=${date_end}&page=${page || 1}&per_page=${per_page || 10}&employeesId=${employeesId}&patientsId=${patientsId}&payment_history=${payment_history}`, {
    responseType: "blob",
  });
  return response.data;
};

export function useRequestReportSchedulingPDFMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: requestReportSchedulingPDF,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["schedulings-report-in-pdf"] });
    },
  });
}
